<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Cambio de médico</h1>
  <div mat-dialog-content>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <h3 *ngIf="!existsPhysicians && !loading" >No es posible reemplazar al médico</h3>
    <mat-form-field *ngIf="!loading && existsPhysicians" class="full-width">
      <input type="text" #physician matInput placeholder="Médico" required formControlName="Physician" [matAutocomplete]="autPhysician">
      <mat-autocomplete #autPhysician="matAutocomplete"  [displayWith]="filterCompletePhysicians.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptions | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="f.Physician.errors && f.Physician.errors.validAutoCompleteSelect">
        Ingrese el médico
      </mat-error>
    </mat-form-field>
  </div>
  <div class="clearfix">
    <div  *ngIf="!loading" class="pull-right">
      <button  *ngIf="existsPhysicians" mat-button type="submit">Guardar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>


